import { Form, message } from 'antd';
import { useDispatch } from 'dva';
import { useState, useCallback, useEffect } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import Loading from '@/components/Loading';
import styles from './AddRule.less?modules';
// import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
// import SelectML from '@/components/select_ml/SelectML';
import SelectML from '@/components/select_ml/add_select_ml/AddSelectML';
import SingInputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import { toOption } from '@/utils/comUtil.js';
import { ruleStatusMap } from '@/constants.js';

const AddRule = (props) => {
  const { parents = {}, handleStatus = 'add' } = props || {};
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const setFrom = useCallback(() => {
    if (handleStatus === 'edit') {
      form.setFieldsValue({
        ...parents,
      });
    }
  }, [form, handleStatus, parents]);
  useEffect(() => {
    setFrom();
  }, [setFrom]);

  // 发起请求
  const onFinish = (values) => {
    const { id } = parents || {};
    if (id) {
      values['parentId'] = id;
    }
    setLoading(true);
    if (handleStatus === 'edit') {
      dispatch({
        type: 'ruleManage/editRuleManaList',
        payload: {
          values: {
            ...values,
          },
        },
        callback: () => {
          setLoading(false);
          message.success('编辑成功');
          props.fetchData();
          props.handleCancel();
        },
      });
    } else {
      dispatch({
        type: 'ruleManage/addRuleManaList',
        payload: {
          values: {
            ...values,
          },
        },
        callback: (data) => {
          setLoading(false);
          if (data.code !== 0) {
            message.error(data.message);
          } else {
            message.success('新增成功');
            props.fetchData();
            props.handleCancel();
          }
        },
      });
    }
  };

  const handleCancel = () => {
    props.handleCancel();
  };

  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          <SingInputML
            height="47px"
            labelwidth="130px"
            inputWidth="269px"
            labelVal="规则包名称"
            placeVal="请输入规则包名"
            name="name"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入规则包名',
              },
            ]}
            // allowClear={true}
          />
          <SingInputML
            height="47px"
            labelwidth="130px"
            inputWidth="269px"
            labelVal="规则包描述"
            placeVal="请输入规则包描述"
            name="description"
            // allowClear={true}
            isTextArea={true}
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入规则包描述',
              },
            ]}
          />
          <SelectML
            height="47px"
            labelwidth="130px"
            inputWidth="269px"
            labelVal="规则包状态"
            placeVal="请选择"
            name="ruleBlockStatus"
            // allowClear={true}
            option={toOption(ruleStatusMap)}
            required={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            // htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default AddRule;
